import { ref } from "vue";
import { defineStore } from "pinia";
import { Service } from "@/interfaces/service";

export const useServicesStore = defineStore("services", () => {
  const services = ref<Service[]>([]);

  return {
    services,

    getService(name: string) {
      return services.value.find((service) => service.name === name);
    },

    setServices(value: Service[]) {
      services.value = value;
    },
  };
});
